import React from 'react';
import { messaggiScreenshots } from './reviewsData';

const FeedbackScreenshotCard = ({ screenshot, index }) => (
  <div
    className="review-card bg-bg-card p-4 rounded-lg border border-border-medium hover:border-brand-primary transition-all duration-300 cursor-pointer"
    onClick={() => window.open(screenshot, '_blank')}
  >
    <img
      src={screenshot}
      alt={`Messaggio lettore ${index + 1}`}
      className="w-full h-auto rounded-lg"
    />
    <p className="caption text-text-secondary mt-3 text-center">
      Messaggio {index + 1}
    </p>
  </div>
);

export const FeedbackTab = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {messaggiScreenshots.map((screenshot, index) => (
      <FeedbackScreenshotCard key={screenshot} screenshot={screenshot} index={index} />
    ))}
  </div>
);
